import { AspopRow } from '../types/networks';

// Embedded fallback: top networks per country from APNIC aspop (stats.labs.apnic.net/aspop/{CC}).
// Approximate snapshot captured at compilation; % of global internet is derived from users ÷ 6.12B.
export const ASPOP_SNAPSHOT_AS_OF = '2026-10-05 (embedded snapshot)';

type Row = Omit<AspopRow, 'pctInternet' | 'pctCountryUsers'>;

export const aspopSnapshot: Record<string, Row[]> = {
  IN: [
    { rank: 1, asn: 'AS55836', name: 'Reliance Jio Infocomm', users: 470_000_000 },
    { rank: 2, asn: 'AS45609', name: 'Bharti Airtel', users: 300_000_000 },
    { rank: 3, asn: 'AS38266', name: 'Vodafone Idea', users: 130_000_000 },
    { rank: 4, asn: 'AS9829', name: 'Bharat Sanchar Nigam (BSNL)', users: 45_000_000 },
    { rank: 5, asn: 'AS24560', name: 'Bharti Airtel Broadband', users: 25_000_000 },
  ],
  US: [
    { rank: 1, asn: 'AS7922', name: 'Comcast Cable', users: 70_000_000 },
    { rank: 2, asn: 'AS21928', name: 'T-Mobile USA', users: 60_000_000 },
    { rank: 3, asn: 'AS7018', name: 'AT&T Services', users: 45_000_000 },
    { rank: 4, asn: 'AS22394', name: 'Verizon Wireless (Cellco)', users: 40_000_000 },
    { rank: 5, asn: 'AS20115', name: 'Charter Communications', users: 35_000_000 },
  ],
  CN: [
    { rank: 1, asn: 'AS9808', name: 'China Mobile', users: 380_000_000 },
    { rank: 2, asn: 'AS4134', name: 'China Telecom', users: 375_000_000 },
    { rank: 3, asn: 'AS4837', name: 'China Unicom', users: 230_000_000 },
    { rank: 4, asn: 'AS4812', name: 'China Telecom Shanghai', users: 30_000_000 },
    { rank: 5, asn: 'AS17816', name: 'China Unicom IP Network', users: 20_000_000 },
  ],
  ID: [
    { rank: 1, asn: 'AS23693', name: 'Telkomsel', users: 90_000_000 },
    { rank: 2, asn: 'AS4761', name: 'Indosat Ooredoo Hutchison', users: 45_000_000 },
    { rank: 3, asn: 'AS24203', name: 'XL Axiata', users: 40_000_000 },
    { rank: 4, asn: 'AS45727', name: 'Hutchison 3 Indonesia', users: 35_000_000 },
    { rank: 5, asn: 'AS7713', name: 'Telkom Indonesia', users: 25_000_000 },
  ],
  BR: [
    { rank: 1, asn: 'AS26599', name: 'Telefônica Brasil (Vivo)', users: 45_000_000 },
    { rank: 2, asn: 'AS28573', name: 'Claro', users: 40_000_000 },
    { rank: 3, asn: 'AS26615', name: 'TIM Brasil', users: 30_000_000 },
    { rank: 4, asn: 'AS18881', name: 'Telefônica Brasil (fixed)', users: 15_000_000 },
    { rank: 5, asn: 'AS7738', name: 'Oi (Telemar)', users: 8_000_000 },
  ],
  PK: [
    { rank: 1, asn: 'AS45669', name: 'Jazz (Mobilink)', users: 40_000_000 },
    { rank: 2, asn: 'AS59257', name: 'Zong (China Mobile Pak)', users: 30_000_000 },
    { rank: 3, asn: 'AS24499', name: 'Telenor Pakistan', users: 25_000_000 },
    { rank: 4, asn: 'AS17557', name: 'Pakistan Telecommunication (PTCL)', users: 10_000_000 },
  ],
  NG: [
    { rank: 1, asn: 'AS29465', name: 'MTN Nigeria', users: 60_000_000 },
    { rank: 2, asn: 'AS36873', name: 'Airtel Nigeria', users: 40_000_000 },
    { rank: 3, asn: 'AS37148', name: 'Globacom', users: 30_000_000 },
    { rank: 4, asn: 'AS37076', name: '9mobile (EMTS)', users: 5_000_000 },
  ],
  BD: [
    { rank: 1, asn: 'AS24389', name: 'Grameenphone', users: 45_000_000 },
    { rank: 2, asn: 'AS24432', name: 'Robi Axiata', users: 30_000_000 },
    { rank: 3, asn: 'AS45245', name: 'Banglalink', users: 20_000_000 },
    { rank: 4, asn: 'AS17494', name: 'Bangladesh Telecommunications (BTCL)', users: 3_000_000 },
  ],
  RU: [
    { rank: 1, asn: 'AS12389', name: 'Rostelecom', users: 30_000_000 },
    { rank: 2, asn: 'AS8359', name: 'MTS', users: 25_000_000 },
    { rank: 3, asn: 'AS31133', name: 'MegaFon', users: 22_000_000 },
    { rank: 4, asn: 'AS16345', name: 'Beeline (VimpelCom)', users: 18_000_000 },
    { rank: 5, asn: 'AS15378', name: 'Tele2 Russia', users: 15_000_000 },
  ],
  MX: [
    { rank: 1, asn: 'AS8151', name: 'Telmex (Uninet)', users: 40_000_000 },
    { rank: 2, asn: 'AS28403', name: 'Telcel (Radiomóvil Dipsa)', users: 35_000_000 },
    { rank: 3, asn: 'AS32098', name: 'AT&T Mexico', users: 12_000_000 },
    { rank: 4, asn: 'AS13999', name: 'Megacable', users: 8_000_000 },
    { rank: 5, asn: 'AS22884', name: 'Totalplay', users: 6_000_000 },
  ],
  JP: [
    { rank: 1, asn: 'AS9605', name: 'NTT Docomo', users: 30_000_000 },
    { rank: 2, asn: 'AS2516', name: 'KDDI', users: 25_000_000 },
    { rank: 3, asn: 'AS17676', name: 'SoftBank', users: 22_000_000 },
    { rank: 4, asn: 'AS4713', name: 'NTT OCN', users: 20_000_000 },
    { rank: 5, asn: 'AS2527', name: 'Sony Network (So-net)', users: 6_000_000 },
  ],
  GB: [
    { rank: 1, asn: 'AS2856', name: 'British Telecommunications', users: 18_000_000 },
    { rank: 2, asn: 'AS5089', name: 'Virgin Media', users: 10_000_000 },
    { rank: 3, asn: 'AS12576', name: 'EE', users: 9_000_000 },
    { rank: 4, asn: 'AS5607', name: 'Sky UK', users: 8_000_000 },
    { rank: 5, asn: 'AS5378', name: 'Vodafone UK', users: 7_000_000 },
  ],
  DE: [
    { rank: 1, asn: 'AS3320', name: 'Deutsche Telekom', users: 30_000_000 },
    { rank: 2, asn: 'AS3209', name: 'Vodafone Germany', users: 20_000_000 },
    { rank: 3, asn: 'AS6805', name: 'Telefónica Germany', users: 15_000_000 },
    { rank: 4, asn: 'AS8881', name: '1&1 Versatel', users: 6_000_000 },
  ],
  FR: [
    { rank: 1, asn: 'AS3215', name: 'Orange', users: 22_000_000 },
    { rank: 2, asn: 'AS12322', name: 'Free (Proxad)', users: 14_000_000 },
    { rank: 3, asn: 'AS15557', name: 'SFR', users: 12_000_000 },
    { rank: 4, asn: 'AS5410', name: 'Bouygues Telecom', users: 12_000_000 },
  ],
  VN: [
    { rank: 1, asn: 'AS7552', name: 'Viettel', users: 40_000_000 },
    { rank: 2, asn: 'AS45899', name: 'VNPT', users: 25_000_000 },
    { rank: 3, asn: 'AS18403', name: 'FPT Telecom', users: 15_000_000 },
    { rank: 4, asn: 'AS131429', name: 'MobiFone', users: 10_000_000 },
  ],
  PH: [
    { rank: 1, asn: 'AS132199', name: 'Globe Telecom', users: 45_000_000 },
    { rank: 2, asn: 'AS10139', name: 'Smart Communications', users: 30_000_000 },
    { rank: 3, asn: 'AS9299', name: 'PLDT', users: 20_000_000 },
    { rank: 4, asn: 'AS139831', name: 'DITO Telecommunity', users: 6_000_000 },
  ],
  TR: [
    { rank: 1, asn: 'AS9121', name: 'Türk Telekom', users: 30_000_000 },
    { rank: 2, asn: 'AS16135', name: 'Turkcell', users: 20_000_000 },
    { rank: 3, asn: 'AS15897', name: 'Vodafone Türkiye', users: 15_000_000 },
    { rank: 4, asn: 'AS34984', name: 'Turkcell Superonline', users: 5_000_000 },
  ],
  EG: [
    { rank: 1, asn: 'AS36935', name: 'Vodafone Egypt', users: 30_000_000 },
    { rank: 2, asn: 'AS8452', name: 'TE Data', users: 25_000_000 },
    { rank: 3, asn: 'AS24863', name: 'Orange Egypt', users: 15_000_000 },
    { rank: 4, asn: 'AS36992', name: 'Etisalat Egypt', users: 12_000_000 },
  ],
  IR: [
    { rank: 1, asn: 'AS197207', name: 'Mobile Communication Co. of Iran (MCCI)', users: 45_000_000 },
    { rank: 2, asn: 'AS44244', name: 'Irancell', users: 40_000_000 },
    { rank: 3, asn: 'AS58224', name: 'Telecommunication Co. of Iran (TCI)', users: 10_000_000 },
  ],
  KR: [
    { rank: 1, asn: 'AS4766', name: 'Korea Telecom (KT)', users: 18_000_000 },
    { rank: 2, asn: 'AS9318', name: 'SK Broadband', users: 12_000_000 },
    { rank: 3, asn: 'AS3786', name: 'LG U+', users: 10_000_000 },
  ],
  ZA: [
    { rank: 1, asn: 'AS29975', name: 'Vodacom', users: 15_000_000 },
    { rank: 2, asn: 'AS16637', name: 'MTN South Africa', users: 12_000_000 },
    { rank: 3, asn: 'AS37457', name: 'Telkom SA', users: 10_000_000 },
    { rank: 4, asn: 'AS37168', name: 'Cell C', users: 4_000_000 },
  ],
  CA: [
    { rank: 1, asn: 'AS577', name: 'Bell Canada', users: 10_000_000 },
    { rank: 2, asn: 'AS812', name: 'Rogers Communications', users: 9_000_000 },
    { rank: 3, asn: 'AS852', name: 'TELUS', users: 8_000_000 },
    { rank: 4, asn: 'AS6327', name: 'Shaw Communications', users: 3_000_000 },
  ],
  AU: [
    { rank: 1, asn: 'AS1221', name: 'Telstra', users: 10_000_000 },
    { rank: 2, asn: 'AS4804', name: 'Optus', users: 5_000_000 },
    { rank: 3, asn: 'AS7545', name: 'TPG Telecom', users: 4_000_000 },
    { rank: 4, asn: 'AS133612', name: 'Vodafone Australia', users: 3_000_000 },
  ],
};
